import { type FC } from "react";

import { useRootSelector } from "@ds/hooks";

import {
  selectTemplateExperienceFormation,
  selectTemplateExperienceRoles,
} from "@ds/modules/settings/projects/redux/selectors/experience-formation-selectors";
import { selectCurrentUserProjectId } from "@ds/modules/settings/users/redux/selectors";

import { Wizard } from "@ds/components/wizard";

import { hasRoleStep } from "../../../utils/new-player-role";
import { CreatePlayerProvider, useCreatePlayer } from "./create-player-context";
import { StepFinal } from "./step-final";
import { StepRole } from "./step-role";
import { Step1Main } from "./step1-main";
import { Step2Experience } from "./step2-experience";
import { Step3Pairing } from "./step3-pairing";

const EMPTY_PROPERTIES: TemplateFormationFieldPropertyMap = {};

export const CreatePlayerWizard: FC<{ onClose: () => void }> = ({ onClose }) => {
  const [{ experience }] = useCreatePlayer();
  const projectId = useRootSelector(selectCurrentUserProjectId);
  const roles = useRootSelector(state => selectTemplateExperienceRoles(state, projectId));
  const properties =
    useRootSelector(state => selectTemplateExperienceFormation(state, projectId))?.properties || EMPTY_PROPERTIES;

  return (
    <Wizard width="40vw" height="80vh" onClose={onClose}>
      <Step1Main />
      <Step2Experience roles={roles} />
      {hasRoleStep(roles, experience) && <StepRole roles={roles} properties={properties} />}
      <Step3Pairing />
      <StepFinal successMessage="Player added successfully!" />
    </Wizard>
  );
};

export const CreatePlayerModal: FC<{ onClose: () => void }> = ({ onClose }) => (
  <CreatePlayerProvider>
    <CreatePlayerWizard onClose={onClose} />
  </CreatePlayerProvider>
);
